module.exports = __webpack_public_path__ + "img/awards_trophies.06503132.png";